import { SignedContract } from './signed-contract';

export const mapperToSignedContract = (data: any): SignedContract => ({
  id: data.id,
  version: data.version,
  userStore: data.userStore
    ? {
        id: data.userStore.id,
        name: data.userStore.name,
        signedAt: data.userStoreSignedAt,
      }
    : null,
  userBrand: data.userBrand
    ? {
        id: data.userBrand.id,
        name: data.userBrand.name,
        signedAt: data.userBrandSignedAt,
      }
    : null,
  order: {
    id: data.order.id,
    code: data.order.code,
  },
  url: data.url,
  createdAt: data.createdAt,
  userBrandSignedAt: data.userBrandSignedAt,
  userStoreSignedAt: data.userStoreSignedAt,
  signatureAdditionalInfo: data.signatureAdditionalInfo,
  authenticityUrl: data.authenticityUrl,
});

export const mapperToSignedContracts = (data: any): SignedContract[] =>
  data.map((d: any) => mapperToSignedContract(d));
